export default __webpack_public_path__ + "static/media/pauline_flowers.ff231b5d.jpg";